import { FC, Suspense, useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { EdSkeleton } from 'shared-ui';

import {
  CreatedIdentityUser,
  IdentityUserCreateContainer,
} from './IdentityUserCreateContainer';

export const IdentityUserCreate: FC = () => {
  const navigate = useNavigate();
  const onCreated = useCallback(
    (user: CreatedIdentityUser) => {
      navigate(`../${user.code}`);
    },
    [navigate],
  );
  const onCancel = useCallback(() => {
    navigate(`../`);
  }, [navigate]);

  return (
    <Suspense fallback={<EdSkeleton />}>
      <IdentityUserCreateContainer onCreate={onCreated} onCancel={onCancel} />
    </Suspense>
  );
};
